export default __webpack_public_path__ + "static/media/enterprise.ee2ff83a.png";